export const breakpoints = {
	small: 576,
	medium: 768,
	large: 992,
	xLarge: 1200,
	tallPhone: '(max-width: 360px) and (min-height: 740px)'
  }
  